import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-installation-list',
  templateUrl: './installation-list.component.html',
  styleUrls: ['./installation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationListComponent {}
